import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/edit.svg';

export const IconEdit = createIconComponent(Icon);
